// extracted by mini-css-extract-plugin
module.exports = {"breakpointTablet":"768px","strahovanieNedvizhimosti":"StrahovanieNedvizhimosti_strahovanieNedvizhimosti__RTUUE"};